module.exports = __webpack_public_path__ + "static/media/sair.6f376544.png";